import { render } from "./UserAuthorizationPanel.vue?vue&type=template&id=85fe21d8&scoped=true&ts=true"
import script from "./UserAuthorizationPanel.vue?vue&type=script&lang=ts"
export * from "./UserAuthorizationPanel.vue?vue&type=script&lang=ts"

import "./UserAuthorizationPanel.vue?vue&type=style&index=0&id=85fe21d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85fe21d8"]])

export default __exports__